import { render, staticRenderFns } from "./UserContests.vue?vue&type=template&id=07fe187d"
import script from "./UserContests.vue?vue&type=script&lang=ts"
export * from "./UserContests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports